export default {"src":"https://cdn.jetlend.ru/_next/static/media/dzen-icon.c92423b8.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};